module.exports = __webpack_public_path__ + "img/social_responsibility_book_shop2.be84ada4.jpg";